var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.params.value)?_c('tooltip-media',{attrs:{"MediaData":_vm.data,"iconSize":12}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }